import { render, staticRenderFns } from "./UsersHighlights.vue?vue&type=template&id=1f46df34"
import script from "./UsersHighlights.vue?vue&type=script&lang=js"
export * from "./UsersHighlights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports